import React, { useState, useEffect } from 'react';
import { Link, location, useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import LeftNavItem from './LeftNavItem';
import UserProfile from '../topbar/UserProfile';
import Logout from '../topbar/Logout';
import HelpModalIcon from '../topbar/HelpModalIcon';

import useUserAuth from '../../hook/useUserAuth';
import useGlobalStatus from '../../hook/useGlobalStatus';

import * as urlConstants from '../../constants/url';
import { PRODUCT_NAME } from '../../constants/global';

import { DrawerDesk, BoxNavItem, StackNavIcon, BoxMobileNav, BoxUserProfile } from './leftnavStyle';
import logo from '../../Logo.svg';
import { MenuIcon, MenuOpenIcon, } from '../customStyles/images';
import theme from '../../theme';


const LeftNav = (props) => {
  const { userAuth } = useUserAuth();
  const { drawerOpen, setDrawerOpen, mobileOpen, setMobileOpen } = useGlobalStatus();
  const theme = useTheme();
  const [desktopOpen, setDesktopOpen,] = useState(true);
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  const toggleDrawer = (newOpen) => () => {
    setMobileOpen(newOpen);
  };

  const handleDrawerOpen = () => {
    setDrawerOpen(!drawerOpen);
  }

  return (
    <>
      {/* {
        isDesktop &&
        <Box>
          <DrawerDesk
            variant="permanent"
            onClose={toggleDrawer(false)}
            anchor="left"
            open={drawerOpen}
            sx={{
              zIndex: 500,
              '& .MuiDrawer-paper': {
                width: drawerOpen ? '300px' : '70px',
              }
            }}
          >
            <Link to="/">
              <Stack sx={{ padding: '4px 8px 30px 8px' }}>
                <img src={logo} alt={PRODUCT_NAME} style={{ width: '160px' }} />
              </Stack>
            </Link>

            <Box sx={{ overflow: 'auto' }}>
              <BoxNavItem>
                <LeftNavItem
                  userAuth={userAuth}
                  toggleDrawer={toggleDrawer(false)}
                  isDesktop={isDesktop}
                  isMobile={isMobile}
                  mainColor={'#fff'}
                  drawerOpen={drawerOpen}
                />
              </BoxNavItem>
            </Box>

            <StackNavIcon variant='end-center'>
              <IconButton
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerOpen}
              >
                {drawerOpen ? <MenuOpenIcon /> : <MenuIcon />}
              </IconButton>
            </StackNavIcon>
          </DrawerDesk>
        </Box>
      } */}
      {
        isMobile &&
        <Box>
          <Drawer
            onClose={toggleDrawer(false)}
            anchor="left"
            open={mobileOpen}
            PaperProps={{ sx: { width: '340px' } }}
            sx={{ zIndex: 500 }}
          >
            <BoxMobileNav>
              <Box>
                <BoxUserProfile>
                  <UserProfile
                    isDesktop={isDesktop}
                    isMobile={isMobile}
                    mainColor={theme.palette.grey.w600}
                  />
                </BoxUserProfile>

                {/* <LeftNavItem
                  userAuth={userAuth}
                  toggleDrawer={toggleDrawer(false)}
                  isDesktop={isDesktop}
                  isMobile={isMobile}
                  drawerOpen={drawerOpen}
                  mainColor={theme.palette.text.primary}
                /> */}
              </Box>

              <Box p={1}>
                {/* <Box mb={1}>
                  <HelpModalIcon variant="mobile" />
                </Box> */}
                
                <Logout variant="mobile" />
              </Box>

            </BoxMobileNav>
          </Drawer>
        </Box>
      }
    </>
  )
}

export default LeftNav;